import * as yup from 'yup';

export const AmountValidator = yup
  .number()
  .positive()
  .transform((value: number, originalValue: unknown) =>
    String(originalValue ?? '').trim() === '' || value === 0
      ? undefined
      : value,
  )
  .typeError('isAmount')
  .test('is-decimal', 'isAmount', (amount: number | undefined) => {
    if (amount != undefined) {
      return /^\d+(\.\d{0,2})?$/.test(amount.toString());
    }
    return true;
  });

export const MandatoryAmountValidator = AmountValidator.positive().required();
